/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-title[_ngcontent-%COMP%]{position:relative;z-index:2}.mat-dialog-title[_ngcontent-%COMP%]   mat-toolbar[_ngcontent-%COMP%]{margin:-24px -24px -20px;width:auto}.toolbar[_ngcontent-%COMP%]{width:100%;display:flex}mat-dialog-content[_ngcontent-%COMP%]{position:relative;z-index:1}mat-dialog-actions[_ngcontent-%COMP%]{flex-direction:column;display:block;position:relative}"];
export { styles as styles };
